import React from "react";

import { usePermanent } from "~/tools/use-permanent";

import { PinnedItemsContextProvider, type PinnedItemsContextValue } from "./_pinned-items-context";
import { PinnedItemsState } from "./PinnedItemsState";

export interface PinnedItemsProviderProps {
	initialState?: PinnedItemsState;
}

export const PinnedItemsProvider: React.FC<React.PropsWithChildren<PinnedItemsProviderProps>> = ({
	initialState,
	children,
}) => {
	const context = usePermanent<PinnedItemsContextValue>(() => ({
		state: initialState ?? PinnedItemsState.init(),
	}));

	return <PinnedItemsContextProvider value={context}>{children}</PinnedItemsContextProvider>;
};
